// Slice 9: Ask Favcy.
import { useState } from "react";
import { HelpCircle, Send } from "lucide-react";

const BASE = import.meta.env.BASE_URL;
const auth = (): Record<string, string> => ({ "x-founder-token": localStorage.getItem("founder_token") || "" });

export default function FounderAsk() {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [topic, setTopic] = useState("");
  const [body, setBody] = useState("");

  async function send() {
    if (!topic.trim() || !body.trim() || busy) return;
    setBusy(true);
    try {
      await fetch(`${BASE}api/founder-portal/thread/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...auth() },
        body: JSON.stringify({ body: `Ask Favcy: ${topic.trim()}\n\n${body.trim()}` }),
      });
      setDone(true); setTopic(""); setBody("");
    } finally { setBusy(false); }
  }

  return (
    <div className="max-w-3xl mx-auto px-6 py-8">
      <div className="mb-6">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-white/60 mb-2">Ask Favcy</div>
        <h1 className="text-2xl font-bold tracking-tight mb-2">Anything outside the standard flow</h1>
        <p className="text-sm text-white/65 leading-relaxed max-w-2xl">
          Tax questions. Hiring help. Press queries. Legal panic. Tell us what you need. Your request goes to the right person at Favcy with your company context attached.
        </p>
      </div>

      <div className="bg-white/[0.04] border border-white/[0.08] rounded-xl p-5">
        <label className="text-[11px] font-mono uppercase tracking-wider text-white/60 block mb-1">Topic in one line</label>
        <input
          value={topic} onChange={e => setTopic(e.target.value)} maxLength={140}
          placeholder="ESOP pool design before our seed round"
          data-testid="input-ask-topic"
          className="w-full bg-black/40 border border-white/[0.12] rounded-md px-3 py-2 text-sm text-white outline-none focus:border-[#FF5C00]/50 mb-3"
        />
        <label className="text-[11px] font-mono uppercase tracking-wider text-white/60 block mb-1">What do you need</label>
        <textarea
          value={body} onChange={e => setBody(e.target.value)} maxLength={3000} rows={5}
          placeholder="We are about to close the round. Need a 30 minute view on standard pool sizes for pre-seed in India."
          data-testid="input-ask-body"
          className="w-full bg-black/40 border border-white/[0.12] rounded-md px-3 py-2 text-sm text-white outline-none focus:border-[#FF5C00]/50 mb-3 resize-none"
        />
        {done ? (
          <div className="text-xs text-green-300">Sent. We will respond in your Advisor Thread within 2 working days.</div>
        ) : (
          <button
            onClick={send} disabled={busy || !topic.trim() || !body.trim()}
            data-testid="button-ask-send"
            className="inline-flex items-center gap-1.5 bg-[#FF5C00] hover:bg-[#FF5C00]/90 disabled:opacity-40 text-white text-sm font-semibold rounded-md px-3.5 py-2"
          ><Send className="w-3.5 h-3.5" /> {busy ? "Sending" : "Send to Favcy"}</button>
        )}
      </div>
    </div>
  );
}
